<template>
  <el-dialog
    title="Гарантия сохранности базы данных"
    :visible="visible"
    width="30%"
    @update:visible="updateVisible">
    <p>На&nbsp;сервере ежедневно выполняется автоматическое резервное копирование всех данных клиентов. По&nbsp;Вашему запросы могут быть предоставлены:</p>
    <ul class="list">
      <li>резервные копии данных за&nbsp;последние 30&nbsp;дней</li>
      <li>резервные копии данных на&nbsp;1-е число месяца.</li>
    </ul>
    <p>Гарантированный срок хранения резервных копий данных 30&nbsp;календарных дней.</p>
    <!-- <instruction-link
      class="mt-12"
      tag="div"
      name="backups"
      @click.native="$emit('update:visible', false)">
      Подробнее о бекапах
    </instruction-link> -->
  </el-dialog>
</template>

<script>
  import InstructionLink from '@/components/InstructionLink.vue'

  export default {
    components: {
      InstructionLink
    },

    props: {
      visible: Boolean
    },

    methods: {
      updateVisible(val) {
        this.$emit('update:visible', val)
      }
    }
  }
</script>

<style>
  .list {
    margin: 20px;
  }
</style>